/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import Component from 'can/component/component';
import DomEventsManager from 'scripts/dom-events-manager';
import appContext from 'scripts/app-context';
import appConfig from 'scripts/app-config';
import template from './live-brightcove-video.stache';
import device from 'scripts/utils/device';
import youbora from 'youboralib';
import 'youbora-adapter-videojs';

const brightcoveOptions = _.get(window.globalSettings, 'brightcove');
const youboraOptions = _.get(window.globalSettings, 'youbora', {});

Component.extend({
    tag: 'live-brightcove-video',
    template,
    leakScope: false,
    viewModel: {
        define: {
            isActive: {
                type: 'boolean',
                value: false,
            },
            playerId: {
                type: 'string',
                value: brightcoveOptions.live.playerId,
            },
            accountId: {
                type: 'string',
                value: brightcoveOptions.accountId,
            },
            videoId: {
                type: 'string',
                value: null,
            },
            autoPlay: {
                type: 'boolean',
                value: _.has(brightcoveOptions.live, 'autoPlay')
                    ? brightcoveOptions.live.autoPlay
                    : true,
            },
        },
        onVideoInserted() {
            const videoId = this.attr('videoId');
            const playerUrl = _.get(appConfig, 'urls.api.brightcove.playerUrl');
            const accountId = _.get(brightcoveOptions, 'accountId');
            const playerId = _.get(brightcoveOptions, 'live.playerId');
            const setYouboraAnalytics = this.setYouboraAnalytics.bind(this);
            const self = this;

            if (!playerUrl || !accountId || !playerId) {
                return console.error('Player is not configured correctly');
            }

            window._define = window.define;
            window.define = undefined;

            can.$.getScript(can.sub(playerUrl, { accountId, playerId }))
                .done(() => {
                    window.define = window._define;

                    videojs('live-player').ready(function() {
                        this.catalog.getVideo(videoId, (error, video) => {
                            if (error) {
                                return console.error(
                                    `Video ${videoId} can not be loaded`,
                                );
                            }

                            this.catalog.load(video);

                            if (self.attr('youbora')) {
                                setYouboraAnalytics(this, videoId);
                            }
                        });

                        const videoElement = this.el_.querySelector('video');

                        this.one('ads-ad-started', () => {
                            videoElement.muted = true;
                        });

                        this.one('ads-ad-ended', () => {
                            videoElement.muted = false;
                        });

                        this.one('play', () => {
                            if (this.ima3 && this.ima3.adrequest) {
                                this.ima3.adrequest();
                            }
                        });
                    });
                })
                .fail(function(jqxhr, settings, exception) {
                    console.log('Error getting brightcove player ', exception);
                });
        },
        setYouboraAnalytics(player, videoId) {
            const plugin = new youbora.Plugin({
                accountCode: youboraOptions.accountCode,
            });
            plugin.setOptions({
                'content.title': videoId,
                'content.isLive': true,
                'extraparam.1': this.attr('title'),
                'extraparam.2': 'Mobile Leader Board',
            });
            plugin.setAdapter(new youbora.adapters.Videojs(player));
            plugin.setAdsAdapter(
                new youbora.adapters.Videojs.GenericAdsAdapter(player),
            );
        },
    },
    events: {
        inserted: function() {
            this.viewModel.element = this.element;

            if (
                this.viewModel.attr('accountId') &&
                this.viewModel.attr('playerId') &&
                this.viewModel.attr('videoId')
            ) {
                DomEventsManager.subscribe(this);
                this.viewModel.attr('isActive', true);
                $('html').addClass('scroll-disabled');
            }
        },

        removed: function() {
            $('html').removeClass('scroll-disabled');
            DomEventsManager.unsubscribe(this);
        },
    },
});
